import { DIContainer, InjectedProperty } from "../../Global/Base/DIContainer";
import { ISignatureManager, ISigningSession } from "./CryptoInterfaces";

export class SignatureManager implements ISignatureManager {
    private readonly _signingSessionFactory: () => ISigningSession;

    constructor(@DIContainer.instance.bindFactory(ISigningSession) signingSessionFactory: () => ISigningSession) {
        this._signingSessionFactory = signingSessionFactory;
    }

    /**
     * Otevře novou session, v rámci níž lze provádět další kryptografické operace
     * @param lang Nepovinný atribut určující jazyk GUI, který je potřebný pouze v případě, že se v rámci session bude otevírat GUI, jinak by se neměl posílat. Jazyk musí být ISO 639-1 (en, cs, ...).
     */
    public async openSession(lang?: string): Promise<ISigningSession> {
        const session = this._signingSessionFactory();
        await session.open(lang);
        return session;
    }
}

DIContainer.instance.register(ISignatureManager, SignatureManager, true);

/**
 * Property sloužící pro přístup k SignatureManageru
 */
//export declare const signatureManager: SignatureManager;
//TypeFactoryProperty.bindProperty(TescoSW.Crypto, "signatureManager", ISignatureManager);
export class signatureManager {
    public static get instance(): SignatureManager {
        return {} as any;
    }
}

InjectedProperty.bindProperty(signatureManager, "instance", ISignatureManager);
